import { defineMessages } from 'react-intl';

export default defineMessages({
  downloadTooltip: 'Save as Excel',
});
